import { Fragment, useContext, useEffect, useState } from 'react'
import { Inline, Visible, Hidden, Stack, Text } from '@leroy-merlin-br/backyard-react-ui'

import { Quantity } from '../Quantity'
import { EntryKeyContext } from '../../context/EntryKeyContext'
import * as S from './styled'

const StockFilter = () => {
  const {
    filterByStock,
    query: { minimumStock }
  } = useContext(EntryKeyContext)

  const [inputQuantity, setInputQuantity] = useState(0)

  const onButtonClick = () => {
    filterByStock(inputQuantity)
  }

  const renderQuantity = () => (
    <Quantity
      isDecrementDisabled={inputQuantity <= 1}
      isIncrementDisabled={false}
      updateQuantity={setInputQuantity}
      quantity={inputQuantity}
      submit={onButtonClick}
    />
  )

  const renderButton = () => (
    <S.Button
      size="kilo"
      isStretch
      onClick={onButtonClick}
    >
      Aplicar
    </S.Button>
  )

  useEffect(() => {
    if (minimumStock) {
      setInputQuantity(parseFloat(minimumStock.value, 10))
    }
  }, [minimumStock])

  return (
    <Fragment>
      <S.Stack spacing="bit">
        <Text size="kilo" noMargin bold>Disponibilidade, mínimo de peças:</Text>

        <Hidden giga>
          <Inline spacing="kilo" justify="between" align="bottom" noWrap>
            {renderQuantity()}
            {renderButton()}
          </Inline>
        </Hidden>

        <Visible giga>
          <Stack spacing="kilo">
            {renderQuantity()}
            {renderButton()}
          </Stack>
        </Visible>
      </S.Stack>
    </Fragment>
  )
}

export default StockFilter
